
import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend,
} from "recharts";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ChartTooltip } from "./ChartTooltip";
import type { FBPost, IGPost } from "@/lib/types";

interface DataPoint {
  date: string;
  value: number;
  value2?: number;
}

interface EngagementChartProps {
  title: string;
  data: DataPoint[];
  dataKey?: string;
  dataKey2?: string;
  color?: string;
  color2?: string;
  label1?: string;
  label2?: string;
  fbPosts?: FBPost[];
  igPosts?: IGPost[];
}

export function EngagementChart({
  title, data, dataKey = "value", dataKey2,
  color = "hsl(var(--chart-1))", color2 = "hsl(var(--chart-2))",
  label1 = "Hodnota", label2,
  fbPosts, igPosts,
}: EngagementChartProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-[200px]">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={data}>
              <CartesianGrid strokeDasharray="3 3" className="stroke-border" />
              <XAxis
                dataKey="date"
                tick={{ fontSize: 11, fill: "#a89f93" }}
                tickFormatter={(v) => { const d = new Date(v); return `${d.getDate()}.${d.getMonth() + 1}.`; }}
                stroke="#2e2e2e"
              />
              <YAxis tick={{ fontSize: 11, fill: "#a89f93" }} stroke="#2e2e2e" />
              <Tooltip content={<ChartTooltip fbPosts={fbPosts} igPosts={igPosts} />} />
              {dataKey2 && <Legend />}
              <Area type="monotone" dataKey={dataKey} name={label1} stroke={color} fill={color} fillOpacity={0.1} strokeWidth={2} />
              {dataKey2 && (
                <Area type="monotone" dataKey={dataKey2} name={label2} stroke={color2} fill={color2} fillOpacity={0.1} strokeWidth={2} />
              )}
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}
